
import {
  defineComponent, ref, onMounted, watch,
} from 'vue';
import { useRouter } from 'vue-router';
import { Form, useForm } from 'vee-validate';
import AppInput from '@/components/UI/AppInput.vue';
import AppButton from '@/components/UI/AppButton.vue';
import AppCheckbox from '@/components/UI/AppCheckbox.vue';
import AppSelect from '@/components/UI/AppSelect.vue';
import ValidationService from '@/services/ValidationService';
import { useRegistrationStore } from '../store/registrationStore';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';
// eslint-disable-next-line import/no-cycle
import RegistrationService from '@/modules/registration/services/RegistrationService';
import { ACCOUNT_STATUS, REGISTRATION_STATE, USER_STATUS } from '@/types/enums';
import { ICountries, IPhoneNumberCodes } from '@/types/interfaces';

// defineRule('required', (value:string) => ValidationService.isNotEmpty(value) || 'This field is required');
// defineRule('phone', (value: string) => ValidationService.isPhone(value) || 'Phone is not valid');
// defineRule('min5', (value: string) => ValidationService.isLonger(value, 5) || 'Group name must be at least 5 characters long.');

export default defineComponent({
  components: {
    Form,
    AppInput,
    AppButton,
    AppCheckbox,
    AppSelect,
  },
  setup() {
    const schema = {};

    const router = useRouter();
    const registrationStore = useRegistrationStore();
    const mainStore = useMainStore();

    const phoneNumberValue = ref(registrationStore.phoneNumber);
    const phoneNumberCodeValue = ref(registrationStore.phoneNumberCode);
    const termsAndConditionsValue = ref(false);
    const phoneNumberError = ref('');

    const phoneNumberCodes = ref<IPhoneNumberCodes[]>([]);
    const filteredNumberCodes = ref<IPhoneNumberCodes[]>([]);

    const { countryCode } = registrationStore.createUser;

    function onBeforeSubmit(values) {
      let error = false;

      if (!ValidationService.isNotEmpty(values.phoneNumberCode + values.phoneNumber)) {
        phoneNumberError.value = 'Phone is not valid';
        error = true;
      }
      if (!ValidationService.isLonger(values.phoneNumberCode + values.phoneNumber, 5)) {
        phoneNumberError.value = 'Phone is not valid';
        error = true;
      }
      if (!ValidationService.isPhone(values.phoneNumberCode + values.phoneNumber)) {
        phoneNumberError.value = 'Phone is not valid';
        error = true;
      }
      return !error;
    }

    const { setFieldValue } = useForm();
    function nextStep(values: any) {
      const isFormValid = onBeforeSubmit(values);
      if (!isFormValid) return;
      setFieldValue('phoneNumber', `${values.phoneNumber}`);
      registrationStore.phoneNumberCode = phoneNumberCodeValue.value.toString();
      registrationStore.phoneNumber = phoneNumberValue.value.toString();
      RegistrationService.sendVerifyCode(registrationStore.phoneNumberCode + registrationStore.phoneNumber)
        .then((response) => {
          if (response.success) {
            router.push('step-7a');
          }
        }).catch((e) => {
          if (e?.response?.data?.errorKey === 'INVALID_PHONE_NUMBER') {
            phoneNumberError.value = 'Invalid phone number';
          } else {
            phoneNumberError.value = 'Something gone wrong';
          }
        });
    }

    function normalizePhoneNumberCodes(countries: ICountries[]): IPhoneNumberCodes[] {
      return countries.map((country) => ({
        value: `${country.phoneNumberCode}`,
        label: `${country.phoneNumberCode}`,
        optionLabel: `${country.phoneNumberCode} (${country.label})`,
        key: country.value,
      } as IPhoneNumberCodes));
    }

    function searchNumberCode(query) {
      filteredNumberCodes.value = phoneNumberCodes.value.filter(
        (item) => item.optionLabel.toLowerCase().includes(query.toLowerCase()),
      );
    }

    function onChangeNumberCode() {
      filteredNumberCodes.value = phoneNumberCodes.value;
    }

    function onInputPhoneNumber(value) {
      phoneNumberValue.value = value.replace(/[^0-9]/g, '');
    }

    watch(() => phoneNumberValue.value, (nv, ov) => {
      if ((nv !== ov) && (ov !== null)) {
        phoneNumberError.value = '';
      }
    });

    onMounted(() => {
      if (registrationStore.phoneNumber) {
        phoneNumberValue.value = registrationStore.phoneNumber;
      }
      if (registrationStore.createUser.firstName) {
        RegistrationService.setAccountInfo(registrationStore.createUser).then((response) => {
          if (response.success) {
            mainStore.user.accountStatuses.push(ACCOUNT_STATUS.REGISTERED);
            mainStore.user.registrationState = REGISTRATION_STATE.CONFIRM_PHONE_NUMBER;
            mainStore.user.status = USER_STATUS.CONFIRM_PHONE_NUMBER;
          }
        });
      }
      mainStore.fetchCountries().then(() => {
        phoneNumberCodes.value = normalizePhoneNumberCodes(mainStore.countries);
        filteredNumberCodes.value = phoneNumberCodes.value;
        if (countryCode && !registrationStore.phoneNumberCode) {
          phoneNumberCodeValue.value = mainStore.countries.find((country) => country.value === countryCode)?.phoneNumberCode || '';
        }
      });
      MonitoringService.sendPageMountedSpeed();
    });

    return {
      phoneNumberCodes,
      filteredNumberCodes,
      schema,
      phoneNumberValue,
      phoneNumberCodeValue,
      termsAndConditionsValue,
      phoneNumberError,
      nextStep,
      searchNumberCode,
      onChangeNumberCode,
      onInputPhoneNumber,
    };
  },
});
